'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
require('../../../components/Card/Card.js');
require('../../../components/Card/CardBody.js');
require('../../../components/Card/CardFooter.js');
var CardHeader = require('../../../components/Card/CardHeader.js');
require('../../../components/Card/CardHeaderAddon.js');
require('../../../components/Card/CardEditButton.js');
require('../../../components/Card/CardHeaderEditButton.js');
require('../../../components/Card/CardFooterEditButton.js');
require('../../../components/Card/CardEmpty.js');
var react = require('@chakra-ui/react');
var React = require('react');
var EditCardHeaderAddon = require('./EditCardHeaderAddon.js');
var useEditCard = require('./useEditCard.js');
var EditCardFooterEditButton = require('./EditCardFooterEditButton.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["children"];

/**
 * Edit card header
 *
 * Contains the card title and an edit button.
 */
var EditCardHeader = react.forwardRef(function (props, ref) {
  var _useEditCardContext = useEditCard.useEditCardContext(),
    isEditable = _useEditCardContext.isEditable,
    isEditing = _useEditCardContext.isEditing,
    isEmpty = _useEditCardContext.isEmpty;
  var children = props.children,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var isVisible = !isEditable || isEmpty ? false : !isEditing;
  return /*#__PURE__*/React__default["default"].createElement(CardHeader.CardHeader, _extends__default["default"]({
    ref: ref
  }, rest), children, /*#__PURE__*/React__default["default"].createElement(EditCardHeaderAddon.EditCardHeaderAddon, null, /*#__PURE__*/React__default["default"].createElement(react.Fade, {
    "in": isVisible,
    unmountOnExit: true
  }, /*#__PURE__*/React__default["default"].createElement(EditCardFooterEditButton.EditCardHeaderEditButton, null))));
});
EditCardHeader.displayName = 'EditCardHeader';
exports.EditCardHeader = EditCardHeader;